import React, { useState } from 'react';
import './HomeDriver.css'

import ListarMotoristas from './ListarMotoristas'
import CadastrarMotorista from './CadastrarMotorista'

const HomeDriver = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshDrivers = () => {
    setRefreshKey(prevKey => prevKey + 1); // Força a recriação do ListarMotoristas
  };

  return (
    <div className='home-container'>
      <div className='home-content'>
        <div className='home-conteudo-pagina'>
          <CadastrarMotorista refreshDrivers={refreshDrivers} />
          <ListarMotoristas key={refreshKey} />
        </div>
      </div>
    </div>
  );
};
export default HomeDriver